module.exports = __webpack_public_path__ + "wooden.8af7a13.png";